import { FC } from 'react';
import { formatGenreLabel } from '../../utils/genreLabel';

interface GenreLabelProps {
    genre: string;
}

/** Renders a genre in title case. Callers keep the stored value for identity and matching. */
const GenreLabel: FC<GenreLabelProps> = ({ genre }) => <>{formatGenreLabel(genre)}</>;

export default GenreLabel;
